const GAME_APP = Object.freeze({
  ID: 24,
  APP_ID: 7,
});

const GAME_CONFIG = Object.freeze({
  VUE_APP_GAME_SERVICE_URL: "https://xgame.urbox.dev",
  VUE_APP_CASH_POINT_URL: "https://sandapib.urbox.dev",
});

const REWARD_TOP_UP_ID = [110,108];

export { GAME_APP, GAME_CONFIG, REWARD_TOP_UP_ID };
